import { useRef } from 'react';
import { useActions, useOnClickOutside } from 'utils/hooks';

import { useSelector } from 'react-redux';
import * as sidebarActions from 'store/sidebar/actions';

import Menu from './menu';

const Panel = () => {
  const [togglePanel] = useActions([sidebarActions.togglePanel]);
  const isPanelOpen = useSelector(state => state.sidebar.isPanelOpen);
  const activePanel = useSelector(state => state.sidebar.activePanel);
  const panels = {
    menu: Menu
  };

  const PanelComponent = activePanel ? panels[activePanel] : null;

  const ref = useRef();

  const closeOnClickOutside = () => {
    if (isPanelOpen === true && !document.querySelector('.modal')) {
      togglePanel();
    }
  };

  useOnClickOutside(ref, closeOnClickOutside);

  return (
    <div
      className={`sidebar-panel${isPanelOpen ? ' is-active' : ''}${
        activePanel ? ` panel-open panel-${activePanel}` : ''
      }`}
      ref={ref}
    >
      <div className="sidebar-panel-content d-flex flex-column">
        <div
          className="sidebar-panel-toggle"
          onClick={() => togglePanel(activePanel ? null : 'menu')}
        >
          <div className="sidebar-panel-toggle--burger">
            <div className="sidebar-panel-toggle--burger-inner" />
          </div>
        </div>
        <div className="sidebar-panel-content--inner">
          {PanelComponent ? <PanelComponent /> : null}
        </div>
      </div>
    </div>
  );
};

export default Panel;
